import AppCard from '@nxsys/components/AppCard';
import AppsContent from '@nxsys/components/AppsContainer/AppsContent';
import AppTableContainer from '@nxsys/components/AppTableContainer';
import { useTypedIntl } from '@nxsys/hooks/useTypedIntl';
import { AppDispatch, AppState } from '@nxsys/store';
import { IRELAND, UNITED_KINGDOM } from '@nxsys/store/constants/keys';
import { agencyAction } from '@nxsys/store/slices/agency/reducer/agencySlice';
import { GetEmployeeListParams } from '@nxsys/store/slices/employee/types';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getRegistrationCompletedColumns } from '../columns';
import AppsHeader from '@nxsys/components/AppsContainer/AppsHeader';
import { ActionsHeader } from '../ActionsHeader';
import { PROSPECT_TYPE } from '@nxsys/constants/prospect';

const RegistrationCompletedTab = () => {
  const { messages } = useTypedIntl();

  const { isBureau, payrollCountry, user } = useSelector(
    (state: AppState) => state.appStore,
  );
  const isUK = isBureau && payrollCountry === UNITED_KINGDOM;
  const isIreland = payrollCountry === IRELAND;

  const dispatch = useDispatch<AppDispatch>();
  const { agencyEmployeeList } = useSelector(
    (state: AppState) => state.agencyStore,
  );
  const { loading, list, pagination, queryParams } = agencyEmployeeList;

  useEffect(() => {
    handleFetchData({
      page: 0,
      size: 20,
    });
  }, []);

  const handleFetchData = (params: GetEmployeeListParams) => {
    const newParams = {
      ...params,
    };

    if (!user?.agencyId?.id) {
      return;
    }

    dispatch(
      agencyAction.getAgencyEmployeeList({
        id: user?.agencyId?.id,
        ...newParams,
      }),
    );
  };

  const onChangePagination = (page: number, pageSize: number) => {
    const isPageSizeChanged = pageSize !== pagination.pageSize;
    const shouldResetPage = isPageSizeChanged && pagination.current > 0;
    handleFetchData({
      ...queryParams,
      page: shouldResetPage ? 0 : page - 1,
      size: pageSize,
    });
  };

  return (
    <AppCard>
      <AppsHeader>
        <ActionsHeader
          fetchData={handleFetchData}
          type={PROSPECT_TYPE.REGISTRATION_COMPLETED}
        />
      </AppsHeader>
      <AppsContent>
        <AppTableContainer
          data={list ?? []}
          loading={loading}
          page={pagination.current}
          total={pagination.totalDocs}
          pageSize={pagination.pageSize}
          scroll={{ x: !isBureau ? 8000 : 7000, y: 700 }}
          titleEmpty={messages['prospect.candidate.empty']}
          columns={getRegistrationCompletedColumns({
            isBureau,
            isUK,
            isIreland,
            messages,
          })}
          onChangePagination={onChangePagination}
        />
      </AppsContent>
    </AppCard>
  );
};

export default RegistrationCompletedTab;
